// Translations and the t() lookup. English is bundled; the other languages live in src/lang/<code>.js and are loaded
// on demand (setLang starts the download; until it arrives t() falls back to English, then onLangLoaded re-renders).
// Adding UI text: add the key here (English) and in every src/lang file.

/* ===== i18n ===== */
const L10N={
en:{
  dropHoles:"Drop zones: {n} tiles inside your base where enemies can drop (amber) — close them with walls or buildings",dropNoHoles:"Drop zones: no holes — enemies can only drop outside your base",
  lvShort:"Lv {n}",
  layUndo:"Undo",layErase:"Eraser",layDone:"Done",layClearQ:"Remove every building from this layout?",
  layouts:"Base layouts",layDesc:"Save up to 3 layouts of your village. Edit one: place every building from the tray, then Use it to move your village there.",layoutN:"Layout {n}",layActive:"In use",layMissing:"{n} buildings still to place",layReady:"Ready to use",layEmpty:"Empty",layEdit:"Edit",layUse:"Use",laySaved:"Layout saved",layNeedAll:"Place every building first",layUsed:"Layout {n} is now your village",layAllPlaced:"All placed",layLeft:"{n} left to place",layCopy:"Copy village",layClear:"Clear",laySave:"Save",layAllPlacedD:"Every building is placed — save it.",  goldBow:"Phoenix Bow",
  goldBowD:"A great golden bow with red grips and ruby flame tips. Her arrows turn to gold and fly wrapped in fire.",
  itemBought:"{i} is yours!",
  ownedAll:"You own it.",
  eqdw_ab:"His Eternal Tome is {n} stronger: troops inside it get a bigger damage and speed boost.",
  eqdw_pow:"He hits {n} harder and {n} faster, and so does every troop inside his Eternal Tome.",
  eqdw_hp:"He gets {n} more health, and troops inside his Eternal Tome heal {n} faster.",
  ownedN:"Owned ×{n}",
  buyAnother:"Buy another ({n}/{m})",
  maxOwned:"You own a Fire Cape for every hero who can wear it.",
  capesWorn:"{w}/{n} capes worn",
  moreCapes:"Buy another cape in the Store to dress one more hero.",
  holdTip:"Tip: press and hold a building to drag it somewhere else.",
  holdRowTip:"Row selected: press and hold one of its walls to drag the whole row.",
  copyLink:"Copy link",
  payUse:"Gem purchases are used for token burns and competition prizes.",
  burnsTitle:"$SCLANS burns",
  payQueued:"Payment sent ✓ Your gems are on the way — they arrive automatically within a few minutes (at the latest on your next login). Your tokens are safe.",
  payUnavailable:"Gem purchases are temporarily unavailable. Please try again in about an hour — nothing was charged.",
  payCancelled:"Payment cancelled — nothing was charged.",
  topClans:"Top clans",
  topClansH:"Top 10 clans",
  yourClanRank:"Your clan",
  burnedW:"burned",
  burnedForever:"Burned forever",
  ofSupply:"of the supply",
  priceL:"Price",
  mcapL:"Market cap",
  vol24:"24h vol",
  supplyL:"Supply",
  holdersL:"Holders",
  curveL:"Bonding curve {n}%",
  ofStart:"of {n} at launch",
  allL:"All",
  chartNone:"Chart data is not available right now",
  burnFund:"Every gem purchase funds $SCLANS burns — the supply only goes down.",
  viewSolscan:"View on Solscan",
  burnedSoFar:"burned so far",
  heroesOf:"{n}'s heroes",
  noHeroesYet:"No heroes yet",
  skinsH:"Hero skins",
  upcoming:"Upcoming",
  skinsDesc:"New looks for your heroes are on the way. Every hero starts with the Classic skin.",
  skinClassic:"Classic",
  payNotFound:"Payment sent but not confirmed on-chain yet — your gems will be added automatically as soon as it shows up.",
  payReceived:"Payments received",
  payNone:"No payments yet.",
  trimmed:"{n} extra towers over the new limit were removed — half their cost came back as Bitcoin.",
  restarted:"Your village starts over at Sol Hall 1!",
  payDesc:"Pay {sym} to get gems. Your tokens go to the Sol Clans treasury; gems arrive once the payment is confirmed.",
  payBtn:"Buy",
  _name:"English",
  foundGems:"Found {n} gems!",
  clear:"Clear",
  obsDesc:"Clear it to free up space. You find 1–6 gems inside!",
  obs_bigrock:"Crystal Rock",obs_pumpkin:"Halloween Pumpkin",obs_skull:"Spooky Skull",
  obs_rock:"Rock",
  obs_bush:"Bush",
  obs_oak:"Oak Tree",
  obs_pine:"Pine Tree",
  each:"each",
  availUp:"Ready to upgrade",
  nothingToUp:"Nothing left to upgrade at this Sol Hall level.",
  moreN:"+{n} more",
  bestValue:"Best value",
  heroes:"Heroes",
  b_herohall:"Hero Hall",
  hero_king:"Sun King",
  hero_queen:"Star Archer",
  hero_prince:"Void Prince",
  hero_warden:"Sage Warden",
  hero_champion:"Solar Champion",
  hero_duke:"Ember Duke",
  noHall:"Build a Hero Hall (Sol Hall 4) to unlock heroes.",
  slots:"Hero slots",
  equip:"Equip",
  equipped:"Equipped",
  heroLocked:"Unlocks at Hero Hall {n} (Sol Hall {c})",
  slotsFull:"All hero slots are in use",
  hhFirst:"Upgrade the Hero Hall first",
  d_herohall:"Unlocks heroes and hero slots. Higher levels raise hero level caps.",
  ab_king:"Heals, powers up and summons Sparks.",
  ab_queen:"Turns invisible and heals; double damage while cloaked.",
  ab_prince:"Splash damage boost and heal for 6s.",
  ab_warden:"Opens a big ward where he stands (1.5× a spell) for 10s: troops inside take no damage, heal, hit harder and move faster. Passive: +25% damage aura.",
  ab_champion:"Shield bounces between 4 defenses.",
  ab_duke:"Huge fire blast and a power boost.",
  b_core:"Sol Hall",
  b_mine:"Bitcoin Miner",
  b_well:"SOL Pump",
  b_drill:"ETH Staker",
  b_gvault:"Bitcoin Vault",
  b_evault:"Solana Vault",
  b_vsilo:"ETH Vault",
  b_camp:"Army Camp",
  b_barracks:"Barracks",
  b_vbarracks:"ETH Barracks",
  b_lab:"Laboratory",
  b_hut:"Builder Hut",
  b_cannon:"Cannon",
  b_arc:"Arc Tower",
  b_mortar:"Mortar",
  b_skylance:"Sky Lance",
  b_rune:"Rune Tower",
  b_zapper:"Hidden Zapper",
  b_bombspire:"Bomb Spire",
  b_crossbeam:"Crossbeam",
  b_inferno:"Inferno Pylon",
  b_solart:"Solar Artillery",
  b_scatter:"Scatter Lobber",
  b_obelisk:"Obelisk",
  b_prism:"Prism Tower",
  b_flame:"Flame Fountain",
  b_wall:"Wall",
  t_spark:"Spark",
  t_lancer:"Lancer",
  t_brute:"Brute",
  t_looter:"Looter",
  t_breacher:"Wall Breaker",
  t_drifter:"Balloon",
  t_mage:"Mage",
  t_mender:"Mender",
  t_wyrm:"Dragon",
  t_knight:"Iron Knight",
  t_hatch:"Baby Dragon",
  t_burrower:"Burrower",
  t_storm:"Electro Dragon",
  t_avalanche:"Avalanche",
  t_skyrider:"Sky Rider",
  t_titan:"Volt Titan",
  t_rootrider:"Root Rider",
  t_thrower:"Thrower",
  t_wisp:"Wisp",
  t_charger:"Charger",
  t_reaper:"Reaper",
  t_golem:"Golem",
  t_hexer:"Shaman",
  t_hound:"Magma Hound",
  t_boulder:"Boulderer",
  t_frost:"Frost Golem",
  void:"ETH",
  cat_def:"Defense",
  cat_res:"Resources",
  cat_army:"Army",
  cat_other:"Other",
  lab:"Laboratory",
  research:"Research",
  researching:"Researching",
  labBusy:"The lab is busy",
  noLab:"Build a Laboratory (Sol Hall 3) to research troops.",
  needCore:"Needs Sol Hall {n}",
  needBarracks:"Needs Barracks level {n}",
  needVB:"Needs ETH Barracks level {n}",
  unlocks:"Next Sol Hall unlocks",
  targets:"Targets",
  ground:"Ground",
  air:"Air",
  groundAir:"Ground & Air",
  dps:"Damage / sec",
  constructing:"Under construction",
  hutsMax:"All 5 builder huts built",
  instant:"Instant",
  splash:"splash",
  activates:"Activates after {n} troop space is deployed",
  hiddenTxt:"Hidden until troops come close",
  nextUnlock:"Next level unlocks",
  energyTroops:"Solana troops",
  voidTroops:"ETH troops",
  d_core:"Heart of your base. Upgrade it to unlock more buildings and levels.",
  d_mine:"Mines Bitcoin. Tap to collect.",
  d_well:"Produces Solana for troops and buildings.",
  d_drill:"Earns ETH, used for ETH troops.",
  d_gvault:"Stores Bitcoin.",
  d_evault:"Stores Solana.",
  d_vsilo:"Stores ETH.",
  d_camp:"Houses your army. More camps, bigger army.",
  d_barracks:"Each level unlocks a new Solana troop.",
  d_vbarracks:"Each level unlocks a new ETH troop.",
  d_lab:"Research stronger troop levels.",
  d_hut:"Each hut gives you one more builder.",
  d_cannon:"Heavy single-target shots.",
  d_arc:"Fast lightning with long range.",
  d_mortar:"Slow splash damage. Blind spot up close.",
  d_skylance:"Heavy missiles. Hits air only.",
  d_rune:"Arcane splash against ground and air.",
  d_zapper:"Stays hidden until troops come close, then zaps.",
  d_bombspire:"Splash bombs on ground troops; explodes when destroyed.",
  d_crossbeam:"Long range, very fast bolts.",
  d_inferno:"Beam that ramps up damage the longer it locks on.",
  d_solart:"Huge-range artillery. Wakes up after 60 troop space is deployed.",
  d_scatter:"Heavy splash shells. Blind spot up close.",
  d_obelisk:"Deals bonus damage based on the target max health.",
  d_prism:"Hits three targets at once.",
  d_flame:"Short-range fire splash.",
  d_wall:"Blocks troops until broken.",
  dt_spark:"Fast melee swarm.",
  dt_lancer:"Ranged, shoots over walls.",
  dt_brute:"Tank that heads straight for defenses.",
  dt_looter:"Fast; double damage to resource buildings.",
  dt_breacher:"Blows up walls (40x damage).",
  dt_drifter:"Flying; drops bombs on defenses.",
  dt_mage:"Ranged splash magic.",
  dt_mender:"Flying healer for ground troops.",
  dt_wyrm:"Flying fire-breather with splash.",
  dt_knight:"Armored heavy hitter.",
  dt_hatch:"Small flying fire-breather.",
  dt_burrower:"Tunnels under walls; untargetable while digging.",
  dt_storm:"Flying; lightning chains between buildings.",
  dt_avalanche:"Huge brawler with massive health.",
  dt_skyrider:"Flying; targets defenses.",
  dt_titan:"Damages everything around it.",
  dt_rootrider:"Jumps walls; targets defenses.",
  dt_thrower:"Very long range spear thrower.",
  dt_wisp:"Cheap flying ranged unit.",
  dt_charger:"Leaps over walls to hit defenses.",
  dt_reaper:"Spins and hits everything around.",
  dt_golem:"Tank that targets defenses.",
  dt_hexer:"Tribal spirit-caller: summons Spark warriors and hurls spirit fire.",
  dt_hound:"Flying tank; splits into pups when defeated.",
  dt_boulder:"Throws splash boulders.",
  dt_frost:"Icy tank that targets defenses.",
  perHour:"Per hour",
  producers:"Producing buildings",
  toCollect:"Ready to collect",
  full:"full",
  gemTip:"Finish upgrades instantly. Get gems with $SCLANS, by clearing trees and rocks, or from a Gem Mine.",
  tapToBuy:"Tap to get more gems",
  league:"League",
  nextLeague:"Next league",
  maxLeague:"Top league reached",
  builders:"Builders",
  freeB:"Free builders",
  noUpgrades:"No upgrades running. Tap a building to upgrade it.",
  build:"Build",
  army:"Army",
  defend:"Defend",
  attack:"Attack!",
  chat:"Chat",
  clan:"Clan",
  top:"Top 10",
  settings:"Settings",
  gold:"Bitcoin",
  energy:"Solana",
  gems:"Gems",
  tagline:"Build your base, raid rivals, rise with your clan. Gem purchases fund $SCLANS burns 🔥",
  connect:"Connect wallet",
  connected:"Connected",
  yourName:"Commander name",
  play:"Enter the arena",
  loginNote:"Type your commander name, then log in with your Solana wallet. Your village is saved to your wallet.",
  nameReq:"Name must be 3–16 letters or numbers",
  wallet:"Wallet",
  notConnected:"Not connected",
  disconnect:"Disconnect",
  language:"Language",
  timezone:"Time zone",
  localTime:"Local time",
  rename:"Change name",
  save:"Save",
  global:"Global",
  send:"Send",
  typeMsg:"Say something…",
  noMsgs:"No messages yet. Say hi!",
  joinClanChat:"Join a clan to use clan chat.",
  slow:"Slow down a little",
  noClan:"You are not in a clan yet.",
  createClan:"Create a clan",
  clanName:"Clan name",
  clanType:"Who can join",
  open:"Anyone",
  inviteOnly:"Invite only",
  minTr:"Min. trophies",
  create:"Create",
  join:"Join",
  leave:"Leave clan",
  invite:"Invite",
  invited:"Invited",
  invites:"Your invites",
  accept:"Accept",
  decline:"Decline",
  members:"Members",
  leader:"Leader",
  member:"Member",
  browse:"Find a clan",
  invitePlayers:"Invite players",
  search:"Search players",
  noClans:"No clans yet — start the first one.",
  needInvite:"Invite only",
  tooFew:"Not enough trophies",
  clanCreated:"Clan created",
  joined:"You joined",
  left:"You left the clan",
  from:"from",
  total:"total",
  top10:"Top 10 players",
  yourRank:"Your rank",
  noPlayers:"No players yet.",
  upgrade:"Upgrade",
  finish:"Finish now",
  upgrading:"Upgrading",
  collect:"Collect",
  move:"Move",
  remove:"Remove",removeRow:"Remove row ({n})",
  maxLvl:"Max level",
  coreFirst:"Upgrade the Sol Hall first",
  buildersBusy:"All builders are busy",
  notEnough:"Not enough resources",
  notEnoughGems:"Not enough gems",
  placeHint:"Pick a building, then tap the map to place it.",
  tapPlace:"Tap the map to place",
  moveHint:"Tap where to move it",
  blocked:"That spot is blocked",
  heroPosted:"Hero posted: they roam here and defend this area if your village is raided",
  heroHome:"Hero back at the Hero Hall",
  heroDragHint:"Drag a hero to post them anywhere in your village; drag them onto the Hero Hall to bring them back",
  limit:"Limit reached — upgrade your Sol Hall",
  storageFull:"Storage full — build a Vault",
  done:"Upgrade complete",
  burnTitle:"Burn tokens for gems",
  burnDesc:"Burn {sym} from your Solana wallet. Gems finish upgrades instantly.",
  burn:"Burn",
  rateL:"Rate",
  phantomMissing:"No Solana wallet found. Install Phantom, Solflare, Backpack, Glow or Coinbase Wallet.",
  tokenNotSet:"Token burns open when the token launches.",
  connectFirst:"Connect your wallet first",
  burnFail:"Burn failed",
  burnOk:"Burn confirmed",
  burnWait:"Confirm the payment in your wallet…",
  burnBlocked:"This view can’t reach the Solana network. Burns run on the self-hosted build.",
  earnGems:"You also earn gems by clearing trees and rocks and from the Gem Mine.",
  deploy:"Tap or hold outside the shaded area to deploy",
  trainFirst:"Train troops in Army first",
  endBattle:"End battle",
  findAnother:"Find another",
  skip:"Skip to result",
  returnHome:"Return home",
  timeLeft:"Time left",
  scouting:"Scouting",
  victory:"Victory",
  defeat:"Defeat",
  flawless:"Flawless!",
  held:"Base held!",
  raided:"Base raided",
  destruction:"Destruction",
  raidersDestroyed:"Raiders destroyed",
  loot:"Loot",
  stolen:"Raiders stole",
  bonus:"Defense bonus",
  raid:"Raid",
  defending:"Defending",
  villageLvl:"village level",
  incoming:"Raiders left to land",
  armyFull:"Army is full — build Barracks",
  capacity:"Capacity",
  usedUp:"Troops are used up when deployed.",
  noTroops:"No troops of that type left",
  tooClose:"Too close to a building",
  offline:"Log in with your Solana wallet to use chat, clans, raids on real players and the leaderboard.",
  level:"Level",
  hp:"Hitpoints",
  dmg:"Damage",
  every:"every",
  range:"Range",
  tiles:"tiles",
  stored:"Stored",
  perMin:"/ min",
  storage:"Storage",
  housing:"Housing",
  unlockCore2:"Unlocks at Sol Hall level 2.",
  space:"space",
  timeLeftS:"left",
  b_vault:"Vault",
  d_vault:"Raises storage for Bitcoin and Solana.",
  b_firestorm:"Firestorm Tower",
  d_firestorm:"Sprays flame streams at up to 4 enemies at once, on the ground and in the air.",
  goBarracks:"Go to barracks",
  goSolHall:"Go to Sol Hall",
  solFlame:"Sol Flame",
  eqd_hp:"Your hero gets {n} more health.",
  eqd_dmg:"Your hero hits {n} harder.",
  eqd_spd:"Your hero moves {n} faster.",
  eqd_ab:"Your hero’s ability is {n} stronger.",
  eqd_regen:"Your hero heals {n} of max health while fighting.",
  eq_pow:"Attack power & speed",
  eqd_pow:"Your hero hits {n} harder and {n} faster.",
  eqWorn:"Worn",
  eqNotWorn:"Not worn (a hero can wear {n})",
  heroLevelNeeded:"Unlocks at hero level {n}",
  labSpellStats:"Each spell level adds +12% power (damage, healing, Power strength, Frost Lock time).",
  heals:"Heals",
  trainTroops:"Train troops",
  armyNotFull:"Your army is not full!",
  armyNotFullD:"Only {n} of {c} housing space is trained. Attack anyway?",
  attackAnyway:"Attack anyway",
  trainMore:"Train more",
  cancel:"Cancel",
  clanXpGain:"Clan XP +{n}",
  perkCd:"troop requests every {m} min",
  perkCap:"+{n} Clan Castle space",
  perkWar:"+{n}% war rewards",
  perkScap:"+{n} castle spell",
  clanLevel:"Clan level {n}",
  clanXpHow:"Clan XP comes from clan wars (win 100, draw 60, loss 30, +5 per star) and donations (1 per troop, 2 per spell). The leader’s game adds it.",
  ccDefOut:"Castle troops!",
  replay:"Replay",
  exitReplay:"Exit replay",
  replayEnd:"Replay finished",
  watchReplay:"Watch replay",
  tapToSeeIt:"building — tap to see",
  buildFirstN:"Build {n} more first",
  waitBuilds:"Wait for building to finish",
  tapToSee:"tap to see what",
  beforeSolHall:"Needed before Sol Hall {n}",
  needed:"Needed",
  cat_builders:"Builders",
  upgradeRow:"Upgrade row ({n})",
  selectRow:"Select row ({n})",
  tapPlaceWall:"Tap to place, or drag to lay a line of walls",
  buildersNow:"Builders: {n} ({b} busy)",
  builderAt:"Builder {n} unlocks at Sol Hall {sh}",
  builderGem:"Builder {n}: {g} gems (Gem shop)",
  free:"Free",
  buildAllFirst:"Build everything first",
  stillToBuild:"Still to build",
  nextBuilderAt:"Next builder: #{n} unlocks at Sol Hall {sh}.",
  builderGemTip:"Builder #{n} can be bought for {g} gems in the Builders tab.",
  buildersMaxed:"You have every builder.",
  clearing:"Clearing…",
  b_castle:"Clan Castle",
  d_castle:"Clanmates fill it with troops (and spells from Sol Hall 6) you can drop into any raid. Request every 10 minutes.",
  ccNeedClan:"Join a clan to request troops",
  ccBuildFirst:"Build a Clan Castle first",
  ccCooldown:"You can request again in {m} min",
  ccRequested:"Request sent to your clan",
  ccFull:"That request is already full",
  ccDonated:"Donated to {n}",
  ccReceived:"{n} donation(s) arrived in your Clan Castle",
  ccTroops:"Clan Castle troops",
  ccEmpty:"Empty — ask your clan for troops",
  ccRequest:"Request troops",
  ccInfo:"Clanmates see your request in the Clan menu and send troops from their army. One request every {m} minutes; skip the wait with gems.",
  ccRequests:"Troop requests",
  yourBase:"Your base",
  hutInShop:"Buy in Gem shop",
  extraBuilder:"Builder #{n}",
  extraBuilderD:"One more builder working at the same time. Place the new hut anywhere.",
  owned:"Owned",
  revenge:"Revenge",
  revenged:"Revenged",
  rewardsNav:"Rewards",
  dailyBonus:"Daily bonus",
  day:"Day",
  claimDaily:"Claim today’s gems",
  comeBack:"Come back tomorrow",
  dailyDay:"Day {n} bonus",
  season:"Season",
  seasonInfo:"Each month is a season. When it ends your trophies reset to 0 and you get gems for the league you reached.",
  seasonEnds:"Ends in",
  yourLeague:"Your league",
  lastSeason:"Last season ({s}): {l} with {n} trophies, reward 💎 {g}",
  seasonEnded:"New season! {l} reward: 💎 {g}. Trophies reset to 0.",
  achievements:"Achievements",
  equipment:"Equipment",
  eqFull:"A hero can wear 2 items: take one off first",
  eq_hp:"Health",
  eq_dmg:"Damage",
  eq_spd:"Speed",
  eq_ab:"Ability power",
  eq_regen:"Healing per second",
  equipItem:"Wear",
  unequip:"Take off",
  soundFx:"Sound effects",
  music:"Music",
  ach_raider:"Raider",
  achd_raider:"Win {n} raids",
  ach_stars:"Star collector",
  achd_stars:"Earn {n} stars in raids",
  ach_destroyer:"Destroyer",
  achd_destroyer:"Destroy {n} buildings",
  ach_hall:"Sol Hall",
  achd_hall:"Upgrade your Sol Hall to level {n}",
  ach_miner:"Bitcoin miner",
  achd_miner:"Collect {n} Bitcoin",
  ach_pumper:"Solana pumper",
  achd_pumper:"Collect {n} Solana",
  ach_gardener:"Gardener",
  achd_gardener:"Clear {n} trees and rocks",
  ach_wizard:"Spellcaster",
  achd_wizard:"Cast {n} spells",
  ach_trainer:"Drill sergeant",
  achd_trainer:"Train {n} troops",
  ach_defender:"Defender",
  achd_defender:"Hold your base {n} times",
  ach_trophy:"Trophy hunter",
  achd_trophy:"Reach {n} trophies",
  ach_hero:"Hero master",
  achd_hero:"Get a hero to level {n}",
  ach_clan:"Clan member",
  achd_clan:"Join or create a clan",
  warLateJoin:"You joined after this war started, so this reward is not yours",
  labBtn:"Laboratory",
  labStats:"Each level: +12% health and damage",
  hallNext:"Next Sol Hall level unlocks",
  spells:"Spells",
  sp_lightning:"Sol Strike",
  sp_heal:"Healing",
  sp_rage:"Power",
  sp_freeze:"Frost Lock",
  spd_lightning:"Strikes buildings in a small area with heavy damage.",
  spd_heal:"Stays on the ground 15 seconds, healing your troops in the circle. Drop more to heal faster.",
  spd_rage:"Stays on the ground 15 seconds: troops in the circle hit 50% harder and move 50% faster. Stacks with more Power.",
  spd_freeze:"Defences in the circle stop shooting for 4 seconds.",
  sp_crumble:"Crumble",
  spd_crumble:"Stone spikes burst up under the walls: each wall in the circle loses about a quarter of its health. Three or four casts break most walls. Buildings only get a scratch.",
  spellsFull:"Spell storage is full — upgrade your Sol Hall for more",
  autoTrain:"Re-train my last army and spells automatically after each raid",
  retrained:"Army re-trained ({n} units)",
  raids:"Raids",
  raidLog:"Raids on your base",
  noRaids:"Nobody has raided you yet.",
  nothingLost:"Nothing lost",
  raidedToast:"{name} raided your base! ({n} new raid(s) — see Raids)",
  gb_spells:"Spells",
  gb_spells_d:"From Sol Hall 3, brew spells in the Army menu: Sol Strike, Healing, Power, Crumble (Sol Hall 7) and Frost Lock (Sol Hall 8). In a raid, pick a spell and tap anywhere — even inside the red zone. Your last army and spells are re-trained automatically after a raid.",
  practiceNoTrophies:"Practice: no trophies",
  b_gemmine:"Gem Mine",
  d_gemmine:"Digs up rubies: 1 gem per hour per level (max level 5). Tap to collect.",
  findClan:"Find clan",
  guide:"Guide",
  chooseOpp:"Choose an opponent",
  gemShopTitle:"Gem shop",
  getGems:"Get gems",
  buyRes:"Buy resources",
  fill:"Fill",
  potions:"Potions",
  use:"Use",
  pot_builder:"Builder potion",
  potd_builder:"Every running upgrade jumps 9 hours ahead (like 1 hour at 10x speed).",
  pot_hero:"Hero potion",
  potd_hero:"All heroes gain +5 levels, up to your Hero Hall limit.",
  pot_troop:"Troop potion",
  potd_troop:"Researches every unlocked troop to the max level your Sol Hall allows.",
  potNoUpgrades:"Nothing is upgrading right now",
  potHeroesMax:"Your heroes are already at the Hero Hall limit",
  potTroopsMax:"Your troops are already at max level for this Sol Hall",
  potUsed:"{p} used!",
  copied:"Copied",
  copy:"Copy",
  soon:"soon",
  copyCA:"Copy contract address",
  clanWar:"Clan war",
  warHitSaved:"War attack saved. No loot or trophies in war — rewards come when the war ends.",
  warInfo:"6 vs 6. Each of your top 6 players gets 2 attacks on the enemy line-up within 24 hours. Most stars wins (tie: total destruction). Everyone in the clan can claim Bitcoin, Solana and ETH at the end.",
  warStart:"Search for war",
  warCancel:"Cancel search",
  warSearching:"Searching for an opponent clan…",
  warFound:"War found vs {c}!",
  coLeader:"Co-leader",coMake:"Co-leader",coRemove:"Co-leader",coMade:"⭐ {n} is now a co-leader",coRemoved:"{n} is no longer a co-leader",warByOther:"Another leader of your clan already has a search or challenge open",
  myClan:"My clan",clanChat:"Clan chat",topClansTab:"Top clans",
  clanChallenge:"Clan challenge",warTrophyS:"war trophies",chalBtn:"Challenge",chalSentShort:"Sent",chalPick:"Challenge {c}: how many a side?",chalReplace:"(this replaces the challenge you already sent)",chalSent:"⚔ Challenge sent to {c} ({n} vs {n})",chalDM:"⚔ {c} challenges your clan to a {n} vs {n} war! Open your clan to accept.",chalIn:"{c} challenges you!",chalOut:"Challenge sent to {c}",chalWait:"waiting for their leader",chalAccept:"Accept",chalDecline:"Decline",chalAccepted:"⚔ War on! vs {c}",chalDeclined:"Challenge declined",chalDeclinedDM:"{c} declined your clan challenge.",chalNeed:"needs {n} members on each side",chalBusy:"One of the clans is already at war",chalHow:"Leaders can challenge any clan from Top clans (3 to 30 a side). Wins earn clan war trophies; bigger wars earn more.",topClansHow:"Ranked by clan war trophies ⚔. Leaders: tap ⚔ Challenge to pick a fight.",wShort:"W",dShortW:"D",lShort:"L",lgBronze:"Bronze league",lgSilver:"Silver league",lgGold:"Gold league",lgCrystal:"Crystal league",lgLegend:"Legend league",
  warNeed6:"You need at least 6 members for a clan war.",
  warLeaderOnly:"Only the leader or a co-leader can start or accept wars.",
  warEndsIn:"Ends in",
  warHitsLeft:"your attacks left: {n}",
  warAttack:"Attack in war",
  warNotInLine:"You are not in the war line-up this time.",
  war_win:"Victory! Claim your war reward.",
  war_draw:"Draw. Claim your share.",
  war_loss:"Defeat. You still get a small reward.",
  warClaim:"Claim",
  warClaimed:"War reward claimed",
  warClaimedBtn:"Reward claimed",
  clanFull:"This clan is full (50 members)",
  searchClans:"Search clans by name",
  yourClan:"Your clan",
  leaveFirst:"Leave your current clan to join another one.",
  practiceBase:"Practice base",
  practiceDesc:"A generated base around your level · half the trophies of a real player",
  realPlayer:"Real player",
  realPlayers:"A random player near your Sol Hall ({n} available, clanmates too)",
  noRealPlayers:"No players near your Sol Hall right now",
  gtab_video:"▶ Video",
  gVideoIntro:"New here? Watch the 2-minute walkthrough: build, upgrade, train your army and win your first raid.",
  gtab_basics:"Basics",
  gtab_strategy:"Strategy",
  gtab_troops:"Troops",
  gtab_heroes:"Heroes",
  gTroopsIntro:"Train troops in the Army menu. Unlock them by upgrading the Sol Hall and Barracks; research them in the Laboratory.",
  gHeroesIntro:"Heroes unlock with the Hero Hall. They don't die for good: after a battle they rest, and each has one special ability per battle.",
  roleMelee:"Melee",
  roleRanged:"Ranged",
  roleAir:"Flying",
  roleHeal:"Healer",
  prefDef:"Targets defences",
  prefRes:"Targets resources",
  prefWall:"Targets walls",
  prefHeal:"Heals troops",
  prefAirDef:"Targets air defences",
  prefAny:"Any target",
  tagSplash:"Splash",
  tagJump:"Jumps walls",
  tagBurrow:"Digs under walls",
  tagOnce:"Single use",
  gb_res:"Resources",
  gb_res_d:"Bitcoin comes from Bitcoin Miners, Solana from SOL Pumps and ETH from ETH Stakers (Sol Hall 7). Tap a building to collect. While your Sol Hall is level 1–3, miners and pumps produce 3x faster.",
  gb_hall:"Sol Hall",
  gb_hall_d:"Upgrading the Sol Hall unlocks new buildings, troops and higher levels, and raises your storage. From Sol Hall 7 it also shoots down flying troops.",
  gb_build:"Builders",
  gb_build_d:"Each upgrade keeps one builder busy. Buy more Builder Huts with gems, finish upgrades instantly with gems, or drink a Builder potion.",
  gb_gems:"Gems",
  gb_gems_d:"Clear trees and rocks (1–6 gems), build a Gem Mine (Sol Hall 3), or buy them with $SCLANS. Spend gems on resources and potions.",
  gb_trophy:"Trophies",
  gb_trophy_d:"Raids win or lose trophies. Real players give the most (more for a higher Sol Hall); practice bases give half as many.",
  gb_clan:"Clans",
  gb_clan_d:"Join or create a clan (up to 50 members), chat with your clan or everyone, and fight 6 vs 6 clan wars for Bitcoin, Solana and ETH.",
  gs_scout:"Scout before you drop",
  gs_scout_d:"Find the Sol Hall, mortars and air defences first. Use \"Find another\" until you see a base you can beat.",
  gs_tanks:"Tanks first, damage behind",
  gs_tanks_d:"Send Brutes, Knights or Golems first to soak up fire, then Lancers, Mages or Sparks behind them.",
  gs_walls:"Open the walls",
  gs_walls_d:"Breachers blow holes in walls; Lancers shoot over them; Chargers and Root Riders jump them.",
  gs_air:"Attack from the air",
  gs_air_d:"Dragons, Electro Dragons and Balloons ignore walls. Check for Sky Lances and Sol Hall 7+ rocket launchers first.",
  gs_stars:"How stars work",
  gs_stars_d:"One star for 50% destruction, one for destroying the Sol Hall, one for 100%. Loot follows destruction, and every attack gets at least a little.",
  gs_layout:"Defend smart",
  gs_layout_d:"Keep the Sol Hall in the middle behind walls, cover mortars with cannons (mortars can't hit close), and spread storages so raiders can't grab everything.",
  gs_spend:"Spend before you log off",
  gs_spend_d:"Full storages are an easy target. Start upgrades before leaving, and upgrade collectors early: more income, faster progress.",
  gt_spark:"Best in big groups against weak buildings.",
  gt_lancer:"Hits from behind walls; keep them behind tanks.",
  gt_brute:"Soaks damage so others can work.",
  gt_looter:"Fastest way to steal loot from storages.",
  gt_breacher:"Send a few at a wall right before your army.",
  gt_drifter:"Bombs defences from the air; protect it from air defence.",
  gt_mage:"Wipes out groups of buildings with splash.",
  gt_mender:"Keeps tanks alive; pair with Knights or Golems.",
  gt_wyrm:"Strong all-round air attacker.",
  gt_knight:"Heavy hitter for the core of a base.",
  gt_hatch:"Cheap flying fire for clearing the outside.",
  gt_burrower:"Gets deep into the base without breaking walls.",
  gt_storm:"Chain lightning destroys clustered buildings.",
  gt_avalanche:"Breaks through the toughest buildings.",
  gt_skyrider:"Hunts defences from the air.",
  gt_titan:"Area damage around it; great in the middle.",
  gt_rootrider:"Jumps walls straight onto defences.",
  gt_thrower:"Out-ranges most defences.",
  gt_wisp:"Cheap swarm of flying shooters.",
  gt_charger:"Fast defence hunter that hops walls.",
  gt_reaper:"Spins through crowded bases.",
  gt_golem:"The toughest ETH tank.",
  gt_hexer:"Calls Spark warriors into the fight with spirit fire.",
  gt_hound:"Draws air-defence fire away from dragons.",
  gt_boulder:"Splash damage over walls.",
  gt_frost:"Tough tank that freezes the pace of defences.",
  chooseWalletT:"Log in with a Solana wallet",
  chooseWallet:"Pick your wallet on the login screen",
  walletNone:"No Solana wallet found. Install Phantom, Solflare, Backpack, Glow or Coinbase Wallet.",
  walletMissing:"{w} not found — opening its website so you can install it.",
  logout:"Log out",
  logoutQ:"Log out of Sol Clans?",
  logoutSaved:"Your village is saved to your wallet account. Log in with the same wallet to get it back on any device.",
  logoutLocal:"No wallet is connected, so your village is only saved in this browser. Logging out deletes it. Connect a wallet first to keep it.",
  logoutAnyway:"Log out anyway",
  visiting:"Visiting",
  viewBase:"View village",
  noBase:"This player has no village to show yet.",
  walletFirst:"Log in with your Solana wallet first",
  guestCont:"🎮 Continue as guest",guestNudgeQ:"Like it? 🏰",guestNudgeP:"Log in to keep your village: it comes with you to a new account. Raid real players, join a clan and earn SOL in Clip to Earn.",guestNudgeNo:"Keep playing as guest",
  guestOr:"or",guestPlay:"🎮 Play now as guest",guestSub:"No sign-up · nothing is saved",guestMode:"Guest mode",guestBar:"Progress isn't saved · tap to log in",guestHi:"👋 Welcome! You're playing as a guest: have fun, nothing is saved.",guestLeaveQ:"Log in to keep playing for real?",guestLeaveP:"Log in with a new wallet and this village becomes yours to keep, plus real-player raids, clans, gems, gifts and Clip to Earn. (An account you already have opens its own village.)",guestLogin:"Go to login",guestStay:"Keep playing",
  openInApp:"Opening Sol Clans inside the {w} app…",
  serverDown:"The game server is not answering right now: you can play, online features are paused.",
  raidTooShort:"That raid ended too fast to count for trophies.",
  raidShielded:"That player is shielded right now; this raid does not count.",
  raidNotCounted:"This raid could not be verified, so it gives no trophies.",
  signAgain:"Please sign in with your wallet again",
  checking:"Checking wallet…",
  wkTitle:"Weekly Top 5 rewards",
  wkTag:"Finish the week in the Top 5 by trophies and claim your prize.",
  wkEnds:"Week ends in",
  dShort:"d",
  wkClaimed:"Week reward for #{r} claimed — well played!",
  wkYouWon:"You finished #{r} last week!",
  wkClaim:"Claim",
  wkLast:"Last week:",
  wkNote:"Weeks end Monday 00:00 UTC. Rewards can be claimed after the week is over, by the players who finished in the Top 5.",
  wkNeedServer:"Weekly rewards are paid by the game server.",
  wkGot:"🏆 Weekly reward: +{g} gems",
  wkNothing:"Nothing to claim for you this week.",
  giftFromBal:"Send from your gems",
  giftFromBalD:"Only gems you bought yourself with {sym} can be sent — reward and gifted gems stay with you.",
  giftCan:"You can send up to 💎 {g}",
  needTokenGems:"Only gems you bought with {sym} yourself can be gifted.",
  giftAmtPh:"Amount (min 10)",
  giftSendGems:"Send gems",
  giftOrBuy:"or buy a gem pack for them",
  potionsDesc:"Your potions. Use one whenever you like, or buy more.",
  potBought:"{p} added to your potions",
  noPotions:"You have none left: buy one first",
  needBoughtGems:"Store items need gems bought with $SCLANS or gifted to you.",
  alreadyOwned:"They already own this item.",
  boughtGemsOnly:"Paid with bought or gifted gems",
  thank:"Thank",
  thanked:"Thanked",
  thanksMsg:"Thank you so much for the {g}! 🙏",
  storeNew:"NEW",
  buyGift:"Buy as a gift",
  giftFor:"Gift for",
  giftItemNote:"Paid with your gems. The item goes straight to their village, with your message in their Inbox.",
  giftSelfItem:"That is your own wallet — use Buy instead.",
  itemSent:"🎁 {i} sent to {n}!",
  itemGot:"🎁 {n} sent you the {i}!",
  dragSpin:"drag to spin",
  spinHint:"Tap a hero, then drag the picture to spin them all the way round.",
  storeTitle:"Sol Clans Store",
  storeTag:"Legendary looks for your heroes.",
  heroEquipH:"Hero equipment",
  heroSkinsH:"Hero skins",
  fireCape:"Fire Cape",
  fireCapeD:"Forged in molten lava — it glows, it flows, it never cools down.",
  queenWar:"Queen of War",
  queenWarD:"A skin for the Star Archer. Every morning the Queen of War puts on her crown and asks one question: \"What are we destroying today?\" Her red-and-gold crossbow fires burning harpoons, so the answer is usually \"everything\".",
  wizardSkin:"Wizard",
  wizardSkinD:"A skin for the Warden: a grumpy old wizard in a tall blue hat and robes, with glowing blue eyes, a long white beard and a shimmering Solana cape. His gnarled staff hurls blue-white lightning.",
  goldKing:"Golden King",
  goldKingD:"A skin for the Sun King: full plate of polished gold, a closed great helm, a black cape, and a sword that blazes with golden light.",
  frostDuke:"Frost Duke",
  frostDukeD:"A skin for the Ember Duke: an ice dragon in a crown of frozen shards. Dark blue eyes glow under the ice, and he breathes frost instead of fire.",
  legendary:"Legendary",
  fitsOn:"Fits",
  looksOnly:"Looks only — no bonuses, your hero stays the same.",
  wornBy:"worn by {n}",
  chooseHero:"Choose hero",
  buy:"Buy",
  moreSoon:"More hero equipment is coming soon.",
  capeBought:"Fire Cape is yours! Choose who wears it in the Hero Hall.",
  specialEq:"Special equipment",
  wearOn:"Wear it on",
  noneWorn:"Nobody",
  notOwnedYet:"You don't own this yet.",
  getInStore:"Get it in the Store",
  notAvailable:"Not available",
  aFriend:"A friend",
  store:"Store",
  openStore:"🛒 Open the store",
  sendGemsH:"Send gems to a friend",
  sendGemsD:"Pay with {sym} — the gems land straight in your friend's village.",
  inbox:"Inbox",
  messages:"Messages",
  gifts:"Gifts",
  gvTitle:"Gem Vault",
  gvTag:"Power up your village — or a friend's.",
  gvBal:"Your gems",
  forMe:"💎 For me",
  giftFriend:"🎁 Gift a friend",
  giftTo:"Friend's Solana wallet",
  giftToPh:"Paste their wallet address",
  giftNote:"Message (optional)",
  giftNotePh:"Happy raiding!",
  giftFound:"Gems go to {n} · Sol Hall {c}",
  giftNone:"No Sol Clans player with this wallet yet.",
  giftSelf:"That is your own wallet — switch to \"For me\".",
  giftBad:"That is not a Solana wallet address.",
  giftBtn:"Gift",
  giftNeedServer:"Gifts need the online server: log in with your wallet.",
  giftPick:"Paste a friend's wallet first.",
  giftSent:"🎁 {g} gems sent to {n}!",
  giftQueued:"Gift paid — {n} gets the gems as soon as the payment is confirmed.",
  giftGot:"🎁 {n} sent you {g} gems!",
  giftFrom:"from {n}",
  giftToN:"to {n}",
  giftsIn:"Received",
  giftsOut:"Sent",
  noGifts:"No gifts yet.",
  sendGift:"🎁 Send a gift",
  noConvos:"No messages yet. Tap ✉ next to a player (Top 10, clan) to write to them.",
  msgPh:"Write a message…",
  msgTo:"Message {n}",
  back:"Back",
  dmPublic:"Messages are not encrypted: keep wallets, seeds and passwords out of them.",
  pending:"pending",
  packN0:"Handful",
  packN1:"Pouch",
  packN2:"Chest",
  packN3:"Dragon hoard",
  spendGems:"Spend gems",
  getGemsH:"Get gems",
  gearH:"Cosmetic hero gear",
  gearDesc:"Looks only — no stats, no pay-to-win. Mix and match on any hero.",
  gear_crown:"Crowns",
  gear_cape:"Capes",
  gear_glow:"Weapon glows",
  gear_aura:"Auras",
  gear_crest:"Shield crests",
  gear_trail:"Footstep trails",
  // Share your raid (share.js): the clip and the post text
  shareRaid:"Share your raid",
  clipMaking:"Making your raid clip…",
  clipReady:"Your raid clip is ready!",
  clipRaidOn:"RAID ON {n}",clanTapMembers:"Tap a clan to see its members and their villages.",
  replayVideo:"Save video",clipRaidBy:"{n} RAIDED MY BASE",clipDefended:"Defended!",clipLostPct:"{p}% destroyed",
  capDefA:"{n} raided my Sol Clans base — {p}% destroyed, {s}⭐ Watch it go down 🔥",capDefB:"{n} came for my base in Sol Clans and took {s}⭐ ({p}%). Revenge is coming ⚔️",
  capDef0a:"{n} tried to raid my Sol Clans base and left with 0⭐ 🛡️ Defence holds 🔥",capDef0b:"Another raid on my Sol Clans base, another 0⭐ for {n} 🛡️😤",
  clipPlay:"PLAY FREE · solclans.com",
  shareX:"Post on X",
  shareTikTok:"TikTok",
  shareMore:"Telegram, WhatsApp…",
  saveVideo:"Save video",
  clipDone:"Done",
  clipCapH:"Your post text (copied when you share):",
  clipShared:"Shared! Thanks for spreading the word ⚔️",
  clipCaptionCopied:"Post text copied — paste it as your TikTok caption.",
  clipDeskX:"Video saved to your Downloads — attach it to the post that just opened on X.",
  clipDeskTT:"Video saved to your Downloads — upload it on the TikTok page that opened, and paste the caption (already copied).",
  clipSaved:"Video saved.",
  clipFail:"Couldn't make the clip on this device — try Chrome or Safari.",
  clipWebm:"Your browser made a WEBM video — if X won't take it, open the game in Chrome or Safari for MP4.",
  cap3a:"Just 3-starred {n} in Sol Clans ⭐⭐⭐ Their base never stood a chance 🔥",
  cap3b:"FLAWLESS raid on {n} — the whole village is gone ⭐⭐⭐⚔️",
  cap3c:"100% wiped — {n} is rebuilding tonight 😈⭐⭐⭐",
  guideSaved:"Video saved to your Downloads ({f})",
  guideX1:"Click \"Open X\" below — your post text is already written.",
  guideX2:"In the post, click the 🖼 picture icon and choose the video from Downloads.",
  guideX3:"Wait until the video shows in the post, then Post.",
  guideOpenX:"Open X",
  guideTT1:"Click \"Open TikTok\" below.",
  guideTT2:"Pick the video from your Downloads.",
  guideTT3:"Paste the caption (Ctrl+V — already copied) and Post.",
  guideOpenTT:"Open TikTok",
  guideTG1:"Click \"Open Telegram\" below and pick the chat or group.",
  guideTG2:"Your message is already written — attach the video from Downloads (📎 or drag it in).",
  guideTG3:"Send!",
  guideOpenTG:"Open Telegram",
  guideWA1:"Click \"Open WhatsApp\" below and pick the chat.",
  guideWA2:"Your message is already written — attach the video from Downloads (📎 or drag it in).",
  guideWA3:"Send!",
  guideOpenWA:"Open WhatsApp",
  guideWeb:"Didn't open? Use the web version",
  shTop:"Top shills",shVid:"▶ Watch how it works (32 s)",shTitle:"Community leaderboard",shTag:"Most views on raid posts on X",
  shStep1:"Win a raid → 🎬 Share your raid → post it on X with the video (keep Sol Clans in the text; the CA is optional).",
  shStep2:"Copy your post's link (Share → Copy link) and paste it below.",
  shStep3:"Points by views: the more people see your post, the more points (up to 7 per post). Points reset every 48 h.",shOk2:"✅ Confirmed! +{p} points ({n} this round). Views are re-checked hourly.",shErrFollow:"Your X account needs at least {n} followers to take part.",shRulesH:"Eligibility rules",shTiersH:"Points per post by views",
  shR1:"Crypto wallet login only.",shR2:"X accounts with at least {n} followers each. Alts are fine; each X account belongs to one player.",shR3:"The post must have your raid video and mention Sol Clans (solclans.com, #SolClans or the name). The CA is optional.",
  shR4:"Only posts made during the current 48-hour round count. Each post counts once.",shR5:"Views are re-checked about every hour. Deleted posts lose their points.",shR6:"The Top 5 when the countdown ends win gems: 1000, 750, 500, 250 and 250. They are added to your village automatically about 6 h after the round (once views are final).",
  shPrize:"48-hour prize round",shPrizeSub:"Top 5 shills win gems, added to their village automatically",shSnap:"Round ends in",
  shPrizeNote:"🔐 Crypto wallet login only. Email accounts don't take part.",shWalletOnly:"Prize rounds are for crypto wallet logins only. Log in with a wallet to join.",
  shSent:"added",shGemsSoon:"gems in ~{h} h",shWon:"📣 Top shill #{r}: +{g} gems!",shLast:"Last round:",shLastH:"Last round's winners",shLastEnd:"ended {d}",shPending:"payout soon",shR7:"A prize needs at least {n} points in the round, even inside the Top 5.",shNeedMin:"needs {n}+ pts for a prize",shUnderMin:"under {n} pts · no prize",phNormal:"Normal",phGolden:"Golden",phVivid:"Vivid",phDream:"Dream",phNoir:"Noir",phTilt:"Tilt-shift",phSave:"Save photo",phExit:"Exit photo mode",phHint:"Drag to move · pinch or scroll to zoom",phSaved:"Photo saved",shPool:"Round fees: {s}",shPaid:"paid",
  shPh:"Paste your X post link",shBtn:"Confirm",shChecking:"Checking your post…",shOk:"✅ Confirmed! You have {n} points",shPts:"pts",
  shClip:"Posted on X? Paste the link to earn a 📣 point:",
  shErrUrl:"That's not an X post link (x.com/…/status/…)",shErrXOnly:"Only X posts count for now",shErrGone:"Couldn't find that post. Is it public?",
  shErrText:"That post doesn't mention Sol Clans. Keep solclans.com or #SolClans in the text.",shErrMedia:"That post has no video or image. Attach your raid clip.",shErrOld:"That post is from before this round. Only posts made this round count.",shErrDup:"That post is already counted ✓",shErrTaken:"Another player already confirmed that post",
  shErrAcct:"That X account belongs to another player",shErrOther:"You already confirmed posts from another X account. Use that one.",shErrFail:"Couldn't check right now. Try again in a minute.",
  shNone:"No confirmed posts yet. Be the first!",shYouNone:"You're not on the board yet: share a raid on X and paste the link.",shNeed:"Log in to see the community leaderboard.",
  shNeedServer:"The community leaderboard needs the game server.",shLoading:"Loading…",
  guideAlready:"Already saved — it's in your Downloads ({f})",
  clipAlready:"Already saved — the video is in your Downloads.",
  capA:"Raided {n} in Sol Clans — {p}% destroyed, {s}⭐ ⚔️🔥",
  capB:"Smashed {p}% of {n} and walked away with the loot 💰⚔️",
  capC:"{s}⭐ raid on {n}. Next time I'm taking the whole village 😤",
  capRival:"a rival clan",
  capTail:"Build. Raid. Rule the chain. Free to play 👉 solclans.com\n$SCLANS #SolClans #Solana #gaming",
  // Email accounts + player IDs (gifts can go to a wallet or an ID)
  emailBtn:"Email",
  emailPh:"Email address",
  passPh:"Password (8+ characters)",
  logIn:"Log in",
  register:"Create account",
  forgotPass:"Forgot password?",
  newPassH:"Choose a new password",
  setPass:"Save new password",
  passChanged:"Password changed ✓",
  checkEmail:"Almost done! We sent you a confirmation email — click the link in it (check spam too), and you're in.",
  resetSent:"If that email has an account, a reset link is on its way.",
  emailBad:"Enter a valid email address.",
  passShort:"The password needs at least 8 characters.",
  loginWrong:"Wrong email or password.",
  emailConfirmFirst:"Confirm your email first — click the link we sent you.",
  emailTaken:"That email already has an account — log in instead.",
  emailSlow:"Too many emails right now — wait a minute and try again.",
  emailFailed:"That didn't work — try again.",
  emailNeedServer:"Email accounts need the online server.",
  emailClosed:"New accounts are paused right now. Log in with a Solana wallet.",
  acctNoBuy:"Gem purchases need a Solana wallet account. Gifts from friends still reach you by your ID.",
  acctId:"Email · ID #{n}",
  playerId:"ID #{n}",
  yourId:"Your player ID: #{n} — friends can send you gifts with it.",
  giftTo:"Friend's Solana wallet or player ID",
  giftToPh:"Wallet address or ID, e.g. #12",
  giftNone:"No Sol Clans player with this wallet or ID yet.",
  giftSelf:"That is you — switch to \"For me\".",
  giftSelfItem:"That is you — use Buy instead.",
  giftBad:"Paste a Solana wallet or a player ID (like #12).",
  giftPick:"Paste a friend's wallet or ID first.",
  giftPackWallet:"Token gem packs can only be gifted to a wallet. Send gems from your balance instead.",
},
ru:{_name:"Русский"},
es:{_name:"Español"}
};
const LOADERS={ru:()=>import('./lang/ru.js'),es:()=>import('./lang/es.js')};
let LANG='en',onLoad=null;const loading={};
/** Download a language's text once (no-op for English or one already here). */
function ensureLang(v){if(!LOADERS[v]||L10N[v]._ok)return Promise.resolve();
  return loading[v]||(loading[v]=LOADERS[v]().then(m=>{Object.assign(L10N[v],m.default);L10N[v]._ok=1;if(LANG===v&&onLoad)onLoad()}).catch(()=>{delete loading[v]}))}
const t=(k,v)=>{let s=(L10N[LANG]&&L10N[LANG][k])||L10N.en[k]||k;if(v)for(const q in v)s=s.split('{'+q+'}').join(v[q]);return s};
export function setLang(v){LANG=v;ensureLang(v)}
/** fn runs when the current language's text has arrived (the game re-renders its texts). */
export function onLangLoaded(fn){onLoad=fn}
/** Resolves when the current language is ready (start-up waits for it, at most a moment). */
export const langReady=()=>ensureLang(LANG);

export { L10N, LANG, t };
